/* eslint-disable @next/next/no-img-element */
import React from 'react';
import Styles from './LoadingModal.css';
import { useLockPageScroll } from '../../../utils/useLayout';
import clsx from 'clsx';

function LoadingModal({ lockScroll, message = '', title = '', variant = 'default' }) {
  useLockPageScroll(lockScroll);

  return (
    <>
      {variant === 'full' && (
        <span
          className="full-header-space"
          onClick={(ev) => {
            ev.preventDefault();
            ev.stopPropagation();
          }}
        />
      )}
      <section
        id="sn-loading-modal"
        className={clsx({ [variant]: true, 'with-title': !!title, 'with-message': !!message })}
      >
        <div className="loader-wrapper">
          <img className="loader-indicator" src="assets/rastreadores/loader.gif" alt="Loading" />

          {!!title && <p className="loading-title">{title}</p>}
          {!!message && <p className="loading-message">{message}</p>}
        </div>
      </section>
      <style jsx>{Styles}</style>
    </>
  );
}

export default LoadingModal;
